import { Box, StatusLabel, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import type { Access } from 'modules/core/components/AccessSelector/types'
import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import { stepStatus } from 'modules/approvals/lib/materializedApprovalFlows'

interface Props {
  overrideApprover: Access
  status: string
}

export const OverrideApproverDecision = ({ overrideApprover, status }: Props) => {
  const [open, toggle] = useToggle(false)
  const statusData = stepStatus(status, false, false)

  return (
    <Box
      padding="s16"
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      flexDirection="row"
      justifyContent="spaceBetween"
    >
      <Box gap="s12" alignItems="center" flexDirection="row">
        <Tooltip.Alt
          key={overrideApprover?.id}
          open={open}
          toggle={toggle}
          attachment="top center"
          label={overrideApprover.fullName}
          textAlign="center"
        >
          <UserAvatar user={overrideApprover} size="s32" />
        </Tooltip.Alt>
        <Text.Normal size="200">
          {i18n.t('settings.approvals.approval_request_view.approval_history.global_approver')}
        </Text.Normal>
      </Box>
      <Box gap="s12" alignItems="center" flexDirection="row">
        <StatusLabel type={statusData.type}>{statusData.label}</StatusLabel>
      </Box>
    </Box>
  )
}
